export enum IOutgoingBankPaymentOperationTypeEnum {
  PaymentToVendor=0,
  paymentToAdnavceHolder=1,
  customsFee=2,
  payrolPaymentToBankAccounts=3,
  cashTransferToOtherAccount=4,
  cashWithdrowalWithFromBank= 5,
  repaymentOfLoansAndBorrowingsReceived = 6,
  transferToDeposits =7 ,
  loanToCounterparty=8,
  loanToEmployee = 9,
  currencyConversion = 10,
  otherExpenses=11,
  refundToCustomer=12,
  intercopanyTransfer = 13,
}

